import colors from "./colors";
import space from "./space";
import boxShadow from "./boxShadow";
import breakpoints from "./breakpoints";

export { colors, space, boxShadow, breakpoints };

export const GREEN = "#4ACB7E";
export const BLACK = "#000000";
